import { useCallback, useState } from 'react';

export default () => {
  const [employee, setEmployee] = useState<any>();

  // 增加数量
  const upDataEmployee = useCallback((value: any) => {
    setEmployee(value);
  }, []);

  return {
    employee,
    upDataEmployee,
  };
};
